import * as React from "react";
const SvgLike = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M9.97 2.172a1.164 1.164 0 0 1 .8.407 1.17 1.17 0 0 1 .261.946l-.435 2.617-.005.025h1.783l.202.01c.063.008.125.019.187.032l.033.009c.049.011.097.024.144.04l.048.015a1.836 1.836 0 0 1 1.184 2.086l-.98-.196a.834.834 0 0 0-.817-.997v.001H9.999a.491.491 0 0 1-.107-.012l-.103-.034a.5.5 0 0 1-.283-.536l.009-.054.528-3.17a.166.166 0 0 0-.003-.072.17.17 0 0 0-.09-.106.167.167 0 0 0-.035-.011l-.036-.005h-.142a1.508 1.508 0 0 0-.709.177l-.156.096c-.15.107-.28.24-.384.395L6.812 6.351a1.83 1.83 0 0 1-.853.686v5.796h5.614a.835.835 0 0 0 .819-.67l.8-4 .98.197-.8 4a1.832 1.832 0 0 1-.746 1.14l-.017.013c-.085.059-.176.109-.27.152l-.013.006a1.85 1.85 0 0 1-.181.07l-.055.017a1.978 1.978 0 0 1-.229.052l-.052.006c-.032.004-.064.009-.096.011l-.013.001c-.042.003-.084.006-.126.006H4.001a1.84 1.84 0 0 1-.35-.035l-.03-.007a1.809 1.809 0 0 1-.452-.16 1.892 1.892 0 0 1-.155-.089l-.048-.03a1.83 1.83 0 0 1-.262-.216c-.3-.301-.487-.696-.528-1.115L2.167 12V6.667c0-.038.006-.076.015-.112a.498.498 0 0 1 .485-.388h2.62v-.001a.838.838 0 0 0 .394-.099.834.834 0 0 0 .3-.272L7.656 3.28l.805.536-.805-.537.019-.025c.038-.056.079-.111.122-.164l.032-.04c.051-.06.106-.117.162-.172l.02-.019c.059-.056.12-.11.184-.16l.025-.018a2.5 2.5 0 0 1 .204-.142l.133-.077a2.488 2.488 0 0 1 1.18-.295h.143c.03 0 .06.003.09.005ZM3.168 7.167V12l.005.086a.833.833 0 0 0 .748.743l.08.004h.709V7.167H3.167Z"
    }
  )
);
export default SvgLike;
